"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "DisabledLink__Wrapper",
  componentId: "sc-1ht5swy-0"
})(["cursor:not-allowed;opacity:0.5;"]);
const DisabledLink = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, children);
};
var _default = exports.default = DisabledLink;